import { render, staticRenderFns } from "./ManageConfig.vue?vue&type=template&id=8c327bf0&scoped=true"
import script from "./ManageConfig.vue?vue&type=script&lang=ts"
export * from "./ManageConfig.vue?vue&type=script&lang=ts"
import style0 from "./ManageConfig.vue?vue&type=style&index=0&id=8c327bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c327bf0",
  null
  
)

export default component.exports